(function() {
  'use strict';

  angular.module('app.shared').factory('EditCareerService', EditCareerService);

  EditCareerService.$inject = ['APP_CONSTANTS', 'ApiCaller', '$filter', '$q'];

  function EditCareerService(APP_CONSTANTS, ApiCaller, $filter, $q) {
    var self = this;

    self.fetchLanguageVariationsForCareer = fetchLanguageVariationsForCareer;

    function fetchLanguageVariationsForCareer(workgroupId, careerId) {
      var deferred = $q.defer();
      var url = $filter('sprintf')(
        APP_CONSTANTS.workgroupCareersLanguageVariation,
        APP_CONSTANTS.rootUrl,
        workgroupId,
        careerId
      );

      ApiCaller.apiGet(url)
        .then(function(result) {
          deferred.resolve(result);
        })
        .catch(function(error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    return self;
  }
})();
